

import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormInputText } from '../sharedComponents/form-components/FormInputText';
import { FormMultilineInputText } from '../sharedComponents/form-components/FormMultilineInputText';
import { AddActionGroups, upsertClientFlows } from '../../service/ApiService';
import { useLocation } from 'react-router-dom';
import AlertMsg from '../sharedComponents/Alert';
import ColorPicker from '../sharedComponents/form-components/ColorPicker';
import { Grid } from '@mui/material';
interface IFormInput {
    title: string
    color: string;
    infoText: string;
}

export const UpsertGroups = ({
    isResetForm,
    isSubmitForm,
    setIsInvalidForm,
    setFormSubmitted,
    dataToSet
}: {
    isResetForm: boolean;
    isSubmitForm: boolean;
    setIsInvalidForm: (isValid: boolean) => void;
    setFormSubmitted: (isValid: boolean) => void;
    dataToSet?: any;
}) => {
    const { handleSubmit, reset, control, setValue, formState } = useForm<IFormInput>({
        defaultValues: {
            title: '',
            color: '',
            infoText: '',
        },
        mode: 'onChange',
    });

    const { isValid } = formState;
    const location = useLocation();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [alertData, setAlertData] = useState<any>();


    useEffect(() => {
        if (dataToSet) {
            setValue('title', dataToSet.title);
            setValue('color', dataToSet.color);
            setValue('infoText', dataToSet.infoText);
        }
    }, [dataToSet, setValue]);

    const openTheSnackbar = () => {
        setOpenSnackbar(true);
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    }

    useEffect(() => {
        if (isResetForm) {
            reset();
        }
    }, [isResetForm]);

    useEffect(() => {
        setIsInvalidForm(isValid);
    }, [isValid, setIsInvalidForm]);

    useEffect(() => {
        const featureId: any = new URLSearchParams(location.search).get(
            "flowId"
        )
        if (isSubmitForm) {
            handleSubmit((data: any) => {
                const payload: any = {
                    id: dataToSet?.id ?? 0,
                    flowId: featureId ?? 0,
                    title: data.title,
                    color: data.color,
                    infoText: data.infoText
                };
                console.log(payload);
                AddActionGroups(payload)
                    .then((response: any) => {
                        openTheSnackbar();
                        if (response.success) {
                            setAlertData({ "type": true, "msg": `The group has been ${dataToSet?.id == 0 ? 'created' : 'updated'} successfully` });
                        } else {
                            setAlertData({ "type": false, "msg": response.errorMessage ?? `The group ${dataToSet?.id == 0 ? 'creation' : 'updation'} was unsuccessful` });
                        }
                        setTimeout(() => {
                            if (response.success) {
                                reset();
                                setFormSubmitted(true);
                            }
                        }, 1000);
                    })
            })();
        }
    }, [isSubmitForm]);

    return (
        <div className='over'>
            <form>
                <Grid className='my-5' container spacing={2}>
                    <Grid item xs={6}>
                        <ColorPicker name="color" control={control} label="Color code" isInlineCss={false} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormInputText name="title" control={control} label="Title" required />
                    </Grid>
                </Grid>
                <FormMultilineInputText name="infoText" control={control} label="Info text" minRows={10} required />
            </form>

            <AlertMsg openSnackbar={openSnackbar} alertdata={alertData} onClose={handleSnackbarClose}
            />
        </div>
    );
};
